import { render, staticRenderFns } from "./grafico.vue?vue&type=template&id=67672cb8&"
import script from "./grafico.vue?vue&type=script&lang=js&"
export * from "./grafico.vue?vue&type=script&lang=js&"
import style0 from "./grafico.vue?vue&type=style&index=0&id=67672cb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports